// Conversation's family lib: the open-ended one plus a `chart` mode - a per-turn breakdown of the whole
// conversation, so it is offered on the Entire conversation overview and not once a turn is picked
// (a picked turn names a sub-level key). Its quote view carries no length preset.

import { calcFamilyLib, isOeViewModeOffered } from '@aytm/app/stats/page/question-views/oe/lib/family'

export const CN_VIEW_MODES_OPTIONS = [
  { key: 'verbatim', text: 'Quote tiles' },
  { key: 'sentiments', text: 'Sentiments' },
  { key: 'tags', text: 'Codebooks' },
  { key: 'chart', text: 'Responses per topic' },
  { key: 'wordcloud', text: 'Wordcloud' }
]

export const CN_DEFAULT_CONFIG = {
  verbatim: { search: { query: [] } },
  wordcloud: { filter: { types: ['respondent'] } }
}

export const CN_FAMILY_LIB = calcFamilyLib({
  viewModesOptions: CN_VIEW_MODES_OPTIONS,
  presetOptions: [],
  defaultConfig: CN_DEFAULT_CONFIG,
  isOffered: (mode, context) =>
    ('chart' === mode && 2 > String(context.key).split('.').length) || isOeViewModeOffered(mode, context)
})
